var map = {
	"./AppleAppStoreIcon": [
		64329,
		4880
	],
	"./AppleAppStoreIcon.tsx": [
		64329,
		4880
	],
	"./ArrowDownFilledIcon": [
		30562,
		2827
	],
	"./ArrowDownFilledIcon.tsx": [
		30562,
		2827
	],
	"./ArrowDownIcon": [
		15926,
		2579
	],
	"./ArrowDownIcon.tsx": [
		15926,
		2579
	],
	"./ArrowLeftIcon": [
		42049,
		2848
	],
	"./ArrowLeftIcon.tsx": [
		42049,
		2848
	],
	"./ArrowRightIcon": [
		3004,
		4817
	],
	"./ArrowRightIcon.tsx": [
		3004,
		4817
	],
	"./ArrowRightStickIcon": [
		90732,
		2521
	],
	"./ArrowRightStickIcon.tsx": [
		90732,
		2521
	],
	"./ArrowUpFilledIcon": [
		3561,
		6832
	],
	"./ArrowUpFilledIcon.tsx": [
		3561,
		6832
	],
	"./ArrowUpIcon": [
		18889,
		5388
	],
	"./ArrowUpIcon.tsx": [
		18889,
		5388
	],
	"./AttentionIcon": [
		60271,
		2558
	],
	"./AttentionIcon.tsx": [
		60271,
		2558
	],
	"./BioIcon": [
		18279,
		5698
	],
	"./BioIcon.tsx": [
		18279,
		5698
	],
	"./BluetoothIcon": [
		64107,
		1266
	],
	"./BluetoothIcon.tsx": [
		64107,
		1266
	],
	"./BuildingIcon": [
		26035,
		4438
	],
	"./BuildingIcon.tsx": [
		26035,
		4438
	],
	"./CalendarIcon": [
		51957,
		80
	],
	"./CalendarIcon.tsx": [
		51957,
		80
	],
	"./ChatIcon": [
		32969,
		9788
	],
	"./ChatIcon.tsx": [
		32969,
		9788
	],
	"./CheckIcon": [
		87437,
		6636
	],
	"./CheckIcon.tsx": [
		87437,
		6636
	],
	"./CloseIcon": [
		16161
	],
	"./CloseIcon.tsx": [
		16161
	],
	"./ConfirmationIcon": [
		53636,
		2021
	],
	"./ConfirmationIcon.tsx": [
		53636,
		2021
	],
	"./CopyIcon": [
		18244,
		393
	],
	"./CopyIcon.tsx": [
		18244,
		393
	],
	"./CupIcon": [
		27765,
		4676
	],
	"./CupIcon.tsx": [
		27765,
		4676
	],
	"./CustomizabilityIcon": [
		8799,
		2158
	],
	"./CustomizabilityIcon.tsx": [
		8799,
		2158
	],
	"./DHLExpressIcon": [
		43599,
		914
	],
	"./DHLExpressIcon.tsx": [
		43599,
		914
	],
	"./DHLIcon": [
		48413,
		1432
	],
	"./DHLIcon.tsx": [
		48413,
		1432
	],
	"./DebitCardIcon": [
		36797,
		6460
	],
	"./DebitCardIcon.tsx": [
		36797,
		6460
	],
	"./DebitIcon": [
		84459,
		5610
	],
	"./DebitIcon.tsx": [
		84459,
		5610
	],
	"./DecalcificationIcon": [
		6383,
		5282
	],
	"./DecalcificationIcon.tsx": [
		6383,
		5282
	],
	"./DeleteIcon": [
		45834,
		623
	],
	"./DeleteIcon.tsx": [
		45834,
		623
	],
	"./DownloadIcon": [
		7551,
		3798
	],
	"./DownloadIcon.tsx": [
		7551,
		3798
	],
	"./EditIcon": [
		26343,
		4414
	],
	"./EditIcon.tsx": [
		26343,
		4414
	],
	"./EditOrderIcon": [
		673,
		2776
	],
	"./EditOrderIcon.tsx": [
		673,
		2776
	],
	"./EyeOff": [
		98938,
		1911
	],
	"./EyeOff.tsx": [
		98938,
		1911
	],
	"./EyeOn": [
		58078,
		9811
	],
	"./EyeOn.tsx": [
		58078,
		9811
	],
	"./FacebookIcon": [
		45735
	],
	"./FacebookIcon.tsx": [
		45735
	],
	"./FacebookMessengerIcon": [
		63648,
		1157
	],
	"./FacebookMessengerIcon.tsx": [
		63648,
		1157
	],
	"./FairTradeIcon": [
		78253,
		5636
	],
	"./FairTradeIcon.tsx": [
		78253,
		5636
	],
	"./FileIcon": [
		48209,
		2108
	],
	"./FileIcon.tsx": [
		48209,
		2108
	],
	"./GoogleAppStoreIcon": [
		926,
		8983
	],
	"./GoogleAppStoreIcon.tsx": [
		926,
		8983
	],
	"./HomeIcon": [
		81030,
		9319
	],
	"./HomeIcon.tsx": [
		81030,
		9319
	],
	"./HouseIcon": [
		42841,
		6532
	],
	"./HouseIcon.tsx": [
		42841,
		6532
	],
	"./InformationIcon": [
		76851,
		9134
	],
	"./InformationIcon.tsx": [
		76851,
		9134
	],
	"./InformationNoPaddingIcon": [
		47729,
		2576
	],
	"./InformationNoPaddingIcon.tsx": [
		47729,
		2576
	],
	"./InstagramIcon": [
		34857
	],
	"./InstagramIcon.tsx": [
		34857
	],
	"./InvoiceIcon": [
		68888,
		6073
	],
	"./InvoiceIcon.tsx": [
		68888,
		6073
	],
	"./InvoiceWhiteIcon": [
		28635,
		7574
	],
	"./InvoiceWhiteIcon.tsx": [
		28635,
		7574
	],
	"./LinkIcon": [
		35087,
		3342
	],
	"./LinkIcon.tsx": [
		35087,
		3342
	],
	"./LogoutIcon": [
		73225,
		8428
	],
	"./LogoutIcon.tsx": [
		73225,
		8428
	],
	"./MasterCardIcon": [
		87283,
		7234
	],
	"./MasterCardIcon.tsx": [
		87283,
		7234
	],
	"./MenuIcon": [
		61546
	],
	"./MenuIcon.tsx": [
		61546
	],
	"./MoreServicesIcon": [
		9288,
		1889
	],
	"./MoreServicesIcon.tsx": [
		9288,
		1889
	],
	"./MoreServicesTextIcon": [
		21069,
		6264
	],
	"./MoreServicesTextIcon.tsx": [
		21069,
		6264
	],
	"./NoWaterIcon": [
		76867,
		4398
	],
	"./NoWaterIcon.tsx": [
		76867,
		4398
	],
	"./OrderConfirmationIcon": [
		24314,
		2883
	],
	"./OrderConfirmationIcon.tsx": [
		24314,
		2883
	],
	"./OrderInvoiceIcon": [
		52734,
		311
	],
	"./OrderInvoiceIcon.tsx": [
		52734,
		311
	],
	"./PauseIcon": [
		50875,
		2786
	],
	"./PauseIcon.tsx": [
		50875,
		2786
	],
	"./PayPalIcon": [
		48014,
		8651
	],
	"./PayPalIcon.tsx": [
		48014,
		8651
	],
	"./PinterestIcon": [
		18215
	],
	"./PinterestIcon.tsx": [
		18215
	],
	"./PlayIcon": [
		94129,
		5824
	],
	"./PlayIcon.tsx": [
		94129,
		5824
	],
	"./PlusIcon": [
		64707,
		9454
	],
	"./PlusIcon.tsx": [
		64707,
		9454
	],
	"./PowerButtonIcon": [
		3374,
		3879
	],
	"./PowerButtonIcon.tsx": [
		3374,
		3879
	],
	"./ReceiptIcon": [
		91697,
		4028
	],
	"./ReceiptIcon.tsx": [
		91697,
		4028
	],
	"./Refresh": [
		95567,
		9342
	],
	"./Refresh.tsx": [
		95567,
		9342
	],
	"./RepairIcon": [
		19556,
		5681
	],
	"./RepairIcon.tsx": [
		19556,
		5681
	],
	"./RepairTextIcon": [
		78737,
		9640
	],
	"./RepairTextIcon.tsx": [
		78737,
		9640
	],
	"./ReturnLabelIcon": [
		48541,
		5352
	],
	"./ReturnLabelIcon.tsx": [
		48541,
		5352
	],
	"./SearchIcon": [
		76415,
		5186
	],
	"./SearchIcon.tsx": [
		76415,
		5186
	],
	"./SecurityIcon": [
		5417,
		68
	],
	"./SecurityIcon.tsx": [
		5417,
		68
	],
	"./Send180Icon": [
		62658,
		2939
	],
	"./Send180Icon.tsx": [
		62658,
		2939
	],
	"./Send4Icon": [
		88391,
		1210
	],
	"./Send4Icon.tsx": [
		88391,
		1210
	],
	"./SendIcon": [
		71445,
		2516
	],
	"./SendIcon.tsx": [
		71445,
		2516
	],
	"./SendWithDotIcon": [
		1778,
		7219
	],
	"./SendWithDotIcon.tsx": [
		1778,
		7219
	],
	"./SoundEqualizerIcon": [
		34084,
		4261
	],
	"./SoundEqualizerIcon.tsx": [
		34084,
		4261
	],
	"./SoundMuteIcon": [
		83019,
		1354
	],
	"./SoundMuteIcon.tsx": [
		83019,
		1354
	],
	"./SquareFilledIcon": [
		84778,
		3371
	],
	"./SquareFilledIcon.tsx": [
		84778,
		3371
	],
	"./SquareIcon": [
		97934,
		3971
	],
	"./SquareIcon.tsx": [
		97934,
		3971
	],
	"./SteeringIcon": [
		69994,
		2855
	],
	"./SteeringIcon.tsx": [
		69994,
		2855
	],
	"./SteeringTextIcon": [
		83303,
		750
	],
	"./SteeringTextIcon.tsx": [
		83303,
		750
	],
	"./TelephoneIcon": [
		87357,
		6272
	],
	"./TelephoneIcon.tsx": [
		87357,
		6272
	],
	"./TwitterIcon": [
		5156,
		1885
	],
	"./TwitterIcon.tsx": [
		5156,
		1885
	],
	"./UpdateIcon": [
		1044,
		9161
	],
	"./UpdateIcon.tsx": [
		1044,
		9161
	],
	"./VideoExpandIcon": [
		40316,
		6337
	],
	"./VideoExpandIcon.tsx": [
		40316,
		6337
	],
	"./VisaCardIcon": [
		1550,
		8507
	],
	"./VisaCardIcon.tsx": [
		1550,
		8507
	],
	"./VolumeControlIcon": [
		64696,
		2853
	],
	"./VolumeControlIcon.tsx": [
		64696,
		2853
	],
	"./WebIcon": [
		44839,
		1010
	],
	"./WebIcon.tsx": [
		44839,
		1010
	],
	"./WhatsAppIcon": [
		1965,
		5964
	],
	"./WhatsAppIcon.tsx": [
		1965,
		5964
	],
	"./Youtube": [
		61957
	],
	"./Youtube.tsx": [
		61957
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61074;
module.exports = webpackAsyncContext;